import { render, staticRenderFns } from "./KloosterList.vue?vue&type=template&id=37719e80&scoped=true"
import script from "./KloosterList.vue?vue&type=script&lang=js"
export * from "./KloosterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37719e80",
  null
  
)

export default component.exports